/* bootloader, loads on click event*/		
const YesBlueBox = function(){
	const common = new bbCommon();
	let omniture; // call this later for race condition purposes
	const bbModel = common.bbModel;
	const noFriendLoad = document.getElementById("noFriendBoxLoad");
	const bbYesLoad = document.getElementById("blueBoxYesLoad");
	const yesBoxBtn = document.getElementById("yesBox");
	
	const init = () =>{
		yesBoxBtn.addEventListener("click", send);
		document.getElementById("yesBox").click();
	};
	
	const send = async (e) =>{
		e.preventDefault();
		
		// set this later to create enough time to prevent a racing condition
		if (!omniture) {
			omniture = common.OmnitureLogBtn();
		}
		
		omniture.BtnPushed("yesBox");
		bbYesLoad.classList.remove("hide");			
		if (yesBoxBtn) common.DisableBlueBtn(yesBoxBtn);
		common.RemoveStatusMsg();	
		if (!document.cookie) common.DisplayCookieMsg();
            	
            	const altBoxSeen = document.getElementById("AltBoxesSeen");
		bbModel.AltBoxesSeen = altBoxSeen ? altBoxSeen.value : "false";
		if (bbModel.AltBoxesSeen == "true") common.GetAltBoxIDs();
  		common.FixBoxModel(bbModel);
  		let responseJSON;
		try{
			const response = await fetch('/bluebox/AcceptBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(bbModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'RequestVerificationToken': common.HeaderToken,
	        			'__RequestVerificationToken': common.HeaderToken
	        		}
			});

			//if (!response.ok) throw new Error('Error processing accept bluebox request');
			responseJSON = await response.json();
		} catch(error){
			acceptFail();
			console.log(error);
		}
		
		if(responseJSON){
			if(responseJSON.model.ShareableBoxID > 0) showFriendDialog(responseJSON);
			else common.DisplayFormSections(responseJSON);
		}
	};
	
	const acceptFail = () =>{
		bbYesLoad.classList.add("hide");				
		common.DisplayStatusMsg();
	};
	
	const showFriendDialog = (response) =>{
		const shareBoxID = document.getElementById("ShareableBoxID");
		shareBoxID.value = response.model.ShareableBoxID;
		yesBoxBtn.setAttribute("aria-expanded", "true");
		
		const btnArea = document.getElementById("blueBoxButtons");
		const addressInfo = document.getElementById("addressInfo");
		const shareForm = document.getElementById("shareableBoxForm");
		btnArea.classList.add("hide");
        	addressInfo.classList.add("hide");
		shareForm.classList.remove("hide");
		
		const editFriendDialog = new EditFriendAddyDialog4i();
		editFriendDialog.Init();

		const noFriendBtn = document.getElementById('noFriendBox');
		noFriendBtn.addEventListener("click", declineFriendBox);
	};
		
	const declineFriendBox = async (e) =>{
		e.preventDefault();
		noFriendLoad.classList.remove("hide");
		common.RemoveStatusMsg();
		let responseJSON;
		try{
			common.FixBoxModel(bbModel);
			const response = await fetch('/bluebox/DeclineFriendBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(bbModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'RequestVerificationToken': common.HeaderToken,
	        			'__RequestVerificationToken': common.HeaderToken
	        		}
			});
			
			//if (!response.ok) throw new Error('Error processing decline friend box request');
			responseJSON = await response.json();
		}catch(error){ 
			declineError();
			console.log(error);
		}
		
		if(responseJSON) common.DisplayFormSections(responseJSON);
	};
	
	const declineError = () => {
		noFriendLoad.classList.add("hide");
		common.DisplayStatusMsg();
	};
	
	return{
		Init: init
	};
};

(async () =>{
	const bbYesBox = new YesBlueBox();
	bbYesBox.Init();
})();